/**
 * Business equipment labels used to separate translation responsibility
 */
export class BusinessEquipmentLabels {
  /**
   * @constructor
   */
  constructor(
    public serial: string,
    public model: string,
    public addEquipment: string,
    public removeEquipment: string,
    public invalidSerialErrorMessage: string,
    public serialServerError: string,
    public equipmentExistsError: string
  ) {}
}
